var policy;
__webpack_require__.tt = () => {
    // Create Trusted Type policy if Trusted Types are available and the policy doesn't exist yet.
    if (policy === undefined) {
        policy = {
            
            
            createScriptURL: (url) => (url),
            
        };
        if (typeof trustedTypes !== "undefined" && trustedTypes.createPolicy) {
            
            try {
            
            policy = trustedTypes.createPolicy("sentry-bundler", policy);
            
            } catch (e) {
                console.warn('Could not create trusted-types policy "sentry-bundler"');
            }
            

        }
    }
    return policy;
}